module.exports = __webpack_public_path__ + "img/logo.1fa3f549.png";